<template>
  <div class="server-info-add">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />
      <q-card-section class="card-content">
        <q-editor
          v-model="fields.info"
          min-height="10rem"
          :toolbar="[
            [
              {
                label: $q.lang.editor.align,
                icon: $q.iconSet.editor.align,
                fixedLabel: true,
                options: ['left', 'center', 'right', 'justify']
              }
            ],
            ['bold', 'italic', 'underline'],
            ['token', 'hr', 'link', 'custom_btn'],
            [
              {
              label: $q.lang.editor.formatting,
              icon: $q.iconSet.editor.formatting,
              list: 'no-icons',
              options: ['p', 'h3', 'h4', 'h5', 'h6', 'code']
              }
            ]
          ]"
        />
            
        <q-btn
          style="width: 100%; margin-top: 16px;"
          class="server-info-add-btn"
          label="Submit"
          @click="submit"
        />
      </q-card-section>

    </q-card>
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from "vuelidate/lib/validators"

import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
  
export default {
  name: 'ServerInfoAdd',
  props: {
    module: {
      require: true,
      type: Object
    }
  },
  setup () {
    return { v$: useVuelidate() }
  },
  validations () {
    return {
      fields: {
        info: {
          required
        }
      }
    }
  },
  created () {
    const info = cloneDeep(this.getServerInfo)

    this.fields.info = info.Info
  },
  data () {
    return {
      fields: {
        info: null,
      }
    }
  },
  methods: {
    ...mapActions({
      requestAddServerInfo: 'home/requestAddServerInfo'
    }),
    async submit () {
      this.v$.fields.$touch();

      if (this.v$.fields.$invalid) {
        return
      }

      this.$q.loading.show();

      await this.recaptchaLoad('addserverinfo')

      await this.requestAddServerInfo(this.fields)
        .then(async response => {
          await this.recaptchaLoad('addserverinfo')

          this.$q.notify({
              position: 'top-right',
              message: response.data.message,
              type: 'positive'
            })
  
            this.$q.loading.hide()
        })
        .catch(error => {
          this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative'
            })
  
            this.$q.loading.hide();
        })
    }
  },
  computed: {
    ...mapGetters({
      getServerInfo: 'home/getServerInfo'
    })
  }
}
</script>
<style lang="scss">
.server-info-add {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      gap: 16px;
    }

    .q-input {
      color: white;
    }

    .q-field__control:before {
      border-color: white;
    }
    
    .server-info-add-btn {
      background-color: #FFC108;
    }
  }
}
</style>